// filtersreducer.ts
import { FilterActionTypes, SET_FILTERS, RESET_FILTERS } from './filter';

interface FilterState {
    filters: any[];
}

const initialState: FilterState = {
    filters: []
};

const filtersReducer = (state = initialState, action: FilterActionTypes): FilterState => {
    switch (action.type) {
        case SET_FILTERS:
            return {
                ...state,
                filters: action.payload
            };
        case RESET_FILTERS:
            return {
                ...state,
                filters: []
            };
        default:
            return state;
    }
};

export default filtersReducer;
